(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/logotype-provider/views/legal.js') >= 0) return;  svs.modules.push('/components/content/logotype-provider/views/legal.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.content=_svs.content||{};
_svs.content.logotype_provider=_svs.content.logotype_provider||{};
_svs.content.logotype_provider.templates=_svs.content.logotype_provider.templates||{};
svs.content.logotype_provider.templates.legal = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"banner-legal\">\n  "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"logotype") : stack1)) != null ? lookupProperty(stack1,"legal") : stack1), depth0))
    + "\n</div>";
},"useData":true});
Handlebars.partials['components-content-logotype_provider-legal'] = svs.content.logotype_provider.templates.legal;
})(svs, Handlebars);

 })(window);